import type { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import type { SearchSortType } from 'modules/search/types/SearchSortType';

import { searchAlgoliaIndex } from './searchAlgoliaIndex';
import { searchAlgoliaVolopsIndex } from './searchAlgoliaVolopsIndex';

export const searchAlgoliaIndexSwitch = ({
  filtersById,
  sort,
}: {
  filtersById: SearchFiltersById;
  sort: SearchSortType;
}) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (filtersById.type) {
    case 'VOLOP':
      return searchAlgoliaVolopsIndex({
        sort,
      });
    case 'EVENT':
      return searchAlgoliaVolopsIndex({
        sort,
      });
    default:
      return searchAlgoliaIndex(sort);
  }
};
